import { connect } from 'react-redux';

import { PERMISSION } from 'constants/logic';
import { selectActiveVenueId, selectUserHasPermission } from 'selectors/general';

import {
  actOnOpportunityFromSchedule as actOnOpportunityFromScheduleAction,
  addSpot,
  setSelectedSchedule,
} from '../YieldManagement.saga';
import { selectActiveScheduleDetailTab } from '../YieldManagement.selectors';
import { SCHEDULE_LIST_V2_ADD_SPOT_TYPE, getScheduleListV2AddSpot } from './ScheduleListV2.helpers';
import ScheduleListV2Item from './ScheduleListV2Item';

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    canManageSpots: selectUserHasPermission(state, PERMISSION.DISPLAY_SPOT_MANAGEMENT),
    tab: selectActiveScheduleDetailTab(state),
    venueId: ownProps.venueId || selectActiveVenueId(state),
  };
}

const mapDispatchToProps = {
  actOnOpportunity: actOnOpportunityFromScheduleAction,
  handleAddSpot: addSpot,
  setSelectedSchedule,
};

function mergeProps(stateProps, dispatchProps) {
  const { canManageSpots, schedule, venueId } = stateProps;
  const { opportunity, scheduleId, scheduleName: className, spots, startDateTime, smartspotEnabled } = schedule || {};
  const { classpassTotal } = spots || {};
  const { actOnOpportunity, handleAddSpot, setSelectedSchedule: setSelected } = dispatchProps;
  const addSpotAction = getScheduleListV2AddSpot(schedule, { canManageSpots });
  const spotsToAdd = addSpotAction?.spotsToAdd;
  const isOpportunity = addSpotAction?.type === SCHEDULE_LIST_V2_ADD_SPOT_TYPE.OPPORTUNITY;

  return {
    ...stateProps,
    actOnOpportunity: () => {
      if (!isOpportunity) {
        return;
      }

      actOnOpportunity({
        venueId,
        schedule,
        opportunities: opportunity ? [opportunity] : [],
        spotsAdded: opportunity?.recommendation || spotsToAdd,
        className,
        startDateTime,
        source: 'schedule list',
      });
    },
    handleAddSpot: () => {
      if (spotsToAdd == null) {
        return;
      }

      handleAddSpot(classpassTotal, scheduleId, classpassTotal + spotsToAdd, smartspotEnabled);
    },
    setSelectedSchedule: setSelected,
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ScheduleListV2Item);
